module.exports = __webpack_public_path__ + "img/rcgyysq.68134fd2.png";